/*@jsxRuntime automatic @jsxImportSource react*/
/*<!-- vale off -->*/
/*<!-- vale on -->*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const title = "Meta Offline Conversions", keywords = "Facebook Offline Conversions, Facebook Ads", lastUpdatedDate = new Date(1764806400000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: "Meta Offline Conversions",
        description: null,
        lastUpdatedDate: "Thu Dec 04 2025 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "facebook-offline",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Supported syncing",
          "depth": 0,
          "id": "supported-syncing"
        }, {
          "value": "Setup Offline Conversions API",
          "depth": 0,
          "id": "setup-offline-conversions-api"
        }, {
          "value": "Connect to Meta Offline Conversions API",
          "depth": 0,
          "id": "connect-to-meta-offline-conversions-api"
        }, {
          "value": "Sync configuration",
          "depth": 0,
          "id": "sync-configuration"
        }, {
          "value": "Syncing events",
          "depth": 1,
          "id": "syncing-events"
        }, {
          "value": "Tips and troubleshooting",
          "depth": 0,
          "id": "tips-and-troubleshooting"
        }, {
          "value": "Common errors",
          "depth": 1,
          "id": "common-errors"
        }, {
          "value": "Live debugger",
          "depth": 1,
          "id": "live-debugger"
        }, {
          "value": "Sync alerts",
          "depth": 1,
          "id": "sync-alerts"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td",
      strong: "strong",
      a: "a",
      p: "p",
      ol: "ol",
      li: "li",
      img: "img",
      h3: "h3",
      code: "code",
      h4: "h4",
      ul: "ul"
    }, _provideComponents(), props.components), {EventSyncWarning, CommonErrorsPreface, LiveDebugger, SyncAlerts} = _components;
    if (!CommonErrorsPreface) _missingMdxReference("CommonErrorsPreface", true);
    if (!EventSyncWarning) _missingMdxReference("EventSyncWarning", true);
    if (!LiveDebugger) _missingMdxReference("LiveDebugger", true);
    if (!SyncAlerts) _missingMdxReference("SyncAlerts", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h2, {
        id: "supported-syncing",
        children: "Supported syncing"
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Type"
            }), _jsx(_components.th, {
              children: "Description"
            }), _jsx(_components.th, {
              children: "Supported Sync Modes"
            }), _jsx(_components.th, {
              children: "API Reference"
            })]
          })
        }), _jsx(_components.tbody, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Events"
              })
            }), _jsx(_components.td, {
              children: "Sync conversion events to Meta's Offline Conversions API"
            }), _jsx(_components.td, {
              children: "Insert"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://developers.facebook.com/docs/marketing-api/offline-conversions/",
                children: "Offline Conversions API reference"
              })
            })]
          })
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["For more information about sync modes, refer to the ", _jsx(_components.a, {
          href: "/syncs/types-and-modes#sync-modes",
          children: "sync modes"
        }), " docs."]
      }), "\n", _jsx(_components.h2, {
        id: "setup-offline-conversions-api",
        children: "Setup Offline Conversions API"
      }), "\n", _jsx(_components.p, {
        children: "To send offline events via Hightouch, you first need to create an app. You can follow these steps to do so:"
      }), "\n", _jsxs(_components.ol, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["In Meta Business Manager, go to ", _jsx(_components.a, {
              href: "https://business.facebook.com/settings/",
              children: "Business Settings"
            }), " and open the ", _jsx(_components.strong, {
              children: "Apps"
            }), " tab under ", _jsx(_components.strong, {
              children: "Accounts"
            }), "."]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Click ", _jsx(_components.strong, {
              children: "Add"
            }), " and select ", _jsx(_components.strong, {
              children: "Create a new app ID"
            }), "."]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-meta-offline-new-apps.png",
          alt: "App creation in Meta"
        })
      }), "\n", _jsxs(_components.ol, {
        start: "3",
        children: ["\n", _jsxs(_components.li, {
          children: ["Select ", _jsx(_components.strong, {
            children: "Other"
          }), " as the use case for the app and click ", _jsx(_components.strong, {
            children: "Next"
          }), "."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-meta-offline-use-case.png",
          alt: "App creation in Meta"
        })
      }), "\n", _jsxs(_components.ol, {
        start: "4",
        children: ["\n", _jsxs(_components.li, {
          children: ["Select ", _jsx(_components.strong, {
            children: "Business"
          }), " as the app type and click ", _jsx(_components.strong, {
            children: "Next"
          }), "."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-meta-offline-app-type.png",
          alt: "App creation in Meta"
        })
      }), "\n", _jsxs(_components.ol, {
        start: "5",
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Add a descriptive name like \"Hightouch Offline Events\" as the app name and click ", _jsx(_components.strong, {
              children: "Create app"
            }), "."]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["This takes you to the app overview page. Copy the ", _jsx(_components.strong, {
              children: "App ID"
            }), " to connect it in the Business Manager."]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-meta-offline-app-id.png",
          alt: "App creation in Meta"
        })
      }), "\n", _jsxs(_components.ol, {
        start: "7",
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Back in ", _jsx(_components.a, {
              href: "https://business.facebook.com/",
              children: "Meta Business Manager"
            }), " and open the ", _jsx(_components.strong, {
              children: "Apps"
            }), " tab."]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Click ", _jsx(_components.strong, {
              children: "Add"
            }), " and select ", _jsx(_components.strong, {
              children: "Connect an app ID"
            }), ". Enter the app ID you previously copied and click ", _jsx(_components.strong, {
              children: "Add app"
            }), "."]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-meta-offline-add-app.png",
          alt: "App creation in Meta"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Next, you need to grant the app ", _jsx(_components.strong, {
          children: "system user access"
        }), ". This lets your app send data to Meta via the API. To create it:"]
      }), "\n", _jsxs(_components.ol, {
        children: ["\n", _jsxs(_components.li, {
          children: ["In ", _jsx(_components.a, {
            href: "https://business.facebook.com/settings/",
            children: "Business Settings"
          }), ", open the ", _jsx(_components.strong, {
            children: "System Users"
          }), " tab under ", _jsx(_components.strong, {
            children: "Users"
          }), " and click ", _jsx(_components.strong, {
            children: "Add"
          }), "."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-meta-offline-add-system-user.png",
          alt: "System user creation in Meta"
        })
      }), "\n", _jsxs(_components.ol, {
        start: "2",
        children: ["\n", _jsxs(_components.li, {
          children: ["Enter a ", _jsx(_components.strong, {
            children: "System user name"
          }), " and select ", _jsx(_components.strong, {
            children: "Admin"
          }), " as the system user role. Click ", _jsx(_components.strong, {
            children: "Create system user"
          }), "."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-meta-offline-add-system-user-2.png",
          alt: "System user creation in Meta"
        })
      }), "\n", _jsxs(_components.ol, {
        start: "3",
        children: ["\n", _jsxs(_components.li, {
          children: ["From the newly created user, click ", _jsx(_components.strong, {
            children: "Generate New Token"
          }), "."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-meta-offline-generate-new-token.png",
          alt: "System user creation in Meta"
        })
      }), "\n", _jsxs(_components.ol, {
        start: "4",
        children: ["\n", _jsxs(_components.li, {
          children: ["Select the app you previously connected and set the ", _jsx(_components.a, {
            href: "https://developers.facebook.com/docs/marketing-api/system-users/install-apps-and-generate-tokens/#types-of-system-access-tokens",
            children: "token expiration"
          }), ". We strongly recommend indefinite access so you don't need to regenerate the token every 60 days. For ", _jsx(_components.strong, {
            children: "Available permissions"
          }), ", select ", _jsx(_components.strong, {
            children: "ads_management"
          }), ". Click ", _jsx(_components.strong, {
            children: "Generate token"
          }), "."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-meta-offline-generate-token.png",
          alt: "Token creation in Meta"
        })
      }), "\n", _jsxs(_components.ol, {
        start: "5",
        children: ["\n", _jsx(_components.li, {
          children: "Copy and store the access token in a secure location as it won't be stored by Meta."
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["Refer to Meta's ", _jsx(_components.a, {
          href: "https://developers.facebook.com/docs/marketing-api/offline-conversions/",
          children: "Offline Conversions API Reference"
        }), " for further information on prerequisites for using the API."]
      }), "\n", _jsx(_components.h2, {
        id: "connect-to-meta-offline-conversions-api",
        children: "Connect to Meta Offline Conversions API"
      }), "\n", _jsxs(_components.p, {
        children: ["Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/destinations?from=docs",
          children: [_jsx(_components.strong, {
            children: "Destinations"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add destination"
        }), " button. Select ", _jsx(_components.strong, {
          children: "Meta Offline Conversions"
        }), " and click ", _jsx(_components.strong, {
          children: "Continue"
        }), ". You can then authenticate Hightouch to ", _jsx(_components.strong, {
          children: "Meta Offline Conversions"
        }), " by entering the ", _jsx(_components.strong, {
          children: "Access Token"
        }), " you previously generated into Hightouch."]
      }), "\n", _jsx(_components.h2, {
        id: "sync-configuration",
        children: "Sync configuration"
      }), "\n", _jsxs(_components.p, {
        children: ["Once you've set up your Meta Offline Conversions destination and have a ", _jsx(_components.a, {
          href: "/getting-started/concepts#models",
          children: "model"
        }), " to pull data from, you can set up your sync configuration to begin syncing data. Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/syncs?from=docs",
          children: [_jsx(_components.strong, {
            children: "Syncs"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add sync"
        }), " button to begin. Then, select the relevant model and the Meta Offline Conversions destination you want to sync to."]
      }), "\n", _jsx(EventSyncWarning, {}), "\n", _jsx(_components.h3, {
        id: "syncing-events",
        children: "Syncing events"
      }), "\n", _jsx(_components.p, {
        children: "First, enter the event set ID that you want to upload events to. You can find your event set ID from the set's setting's tab."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-meta-offline-event-set.png",
          alt: "Event Set ID"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["If you don't have an events set yet, you can create one following ", _jsx(_components.a, {
          href: "https://www.facebook.com/business/help/339320669734609?id=565900110447546",
          children: "these instructions"
        }), ". Make sure the ", _jsx(_components.a, {
          href: "#setup-offline-conversions-api",
          children: "access token"
        }), " you entered ", _jsx(_components.a, {
          href: "https://www.facebook.com/business/help/629677790575687?id=565900110447546",
          children: "has access to this set"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["Enter an upload tag, for example, \"monthly_uploads\" to identify the events. Optionally, you can also enter a namespace identifier. The ", _jsx(_components.a, {
          href: "https://developers.facebook.com/docs/marketing-api/offline-conversions/#upload-events",
          children: "namespace identifier"
        }), " is the scope used to resolve ", _jsx(_components.code, {
          children: "extern_id"
        }), " or ", _jsx(_components.code, {
          children: "tpid"
        }), ". It can be another data set or data partner ID."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-meta-offline-configuration.png",
          alt: "Hightouch sync configuration"
        })
      }), "\n", _jsx(_components.h4, {
        id: "event-timestamp",
        children: "Event timestamp"
      }), "\n", _jsxs(_components.p, {
        children: ["You can optionally select a column that contains timestamps of when events occurred. If this field is empty, Hightouch uses the time the event arrives at the server. Hightouch syncs the timestamp as the ", _jsx(_components.code, {
          children: "event_time"
        }), " parameter the Conversions API requires."]
      }), "\n", _jsxs(_components.p, {
        children: ["If you select a column, it should be in ", _jsx(_components.a, {
          href: "https://www.iso.org/iso-8601-date-and-time-format.html",
          children: "ISO 8601"
        }), " format. Hightouch automatically converts the data to the format Meta expects."]
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping",
        children: "Field mapping"
      }), "\n", _jsx(_components.p, {
        children: "Field mapping is where you can select which event parameters you want to send to the Offline Conversions API. The API expects the following parameters:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.code, {
            children: "event_name"
          }), ": Type of event. For example, ", _jsx(_components.code, {
            children: "ViewContent"
          }), ", ", _jsx(_components.code, {
            children: "Search"
          }), ", ", _jsx(_components.code, {
            children: "AddToCart"
          }), ", ", _jsx(_components.code, {
            children: "AddToWishlist"
          }), ", ", _jsx(_components.code, {
            children: "InitiateCheckout"
          }), ", etc."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.code, {
            children: "currency"
          }), ": Three-letter ISO currency code for this conversion event. Required for ", _jsx(_components.code, {
            children: "Purchase"
          }), " events. For example, ", _jsx(_components.code, {
            children: "USD"
          })]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.code, {
            children: "value"
          }), ": Value of conversion event. Required for Purchase events. For example, ", _jsx(_components.code, {
            children: "16.00"
          }), "."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.code, {
            children: "match_keys"
          }), ": a set of identifiers to match people for attribution. Examples include ", _jsx(_components.code, {
            children: "email"
          }), ", ", _jsx(_components.code, {
            children: "phone"
          }), ", ", _jsx(_components.code, {
            children: "db"
          }), ", etc. Note that these must be ", _jsx(_components.a, {
            href: "#hashing",
            children: "hashed"
          }), "."]
        }), "\n"]
      }), "\n", "\n", _jsxs(_components.p, {
        children: ["The Meta Offline API accepts strings and arrays of strings for ", _jsx(_components.a, {
          href: "https://developers.facebook.com/docs/marketing-api/offline-conversions/#upload-events",
          children: _jsx(_components.code, {
            children: "match_keys"
          })
        }), ". For example, you can use values like ", _jsx(_components.code, {
          children: "\"jane@example.com\""
        }), " or ", _jsx(_components.code, {
          children: "[\"jane@example.com\", \"john@example.com\"]"
        }), " for ", _jsx(_components.code, {
          children: "match_keys.email"
        }), ". The API rejects comma-separated strings, for example, ", _jsx(_components.code, {
          children: "\"jane@example.com, john@example.com\""
        }), ". Ensure the mapped field is in the correct format."]
      }), "\n", "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-meta-offline-sync-columns.png",
          alt: "Hightouch sync configuration"
        })
      }), "\n", _jsx(_components.h4, {
        id: "hashing",
        children: "Hashing"
      }), "\n", _jsx(_components.p, {
        children: "By default, Hightouch automatically hashes the following fields:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "email"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "phone"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "gender"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "doby"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "dobm"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "dobd"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "last name"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "first name"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "first initial"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "city"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "state"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "zip"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "country"
          })
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["If you want to turn hashing off, select ", _jsx(_components.strong, {
          children: "No"
        }), " under ", _jsx(_components.strong, {
          children: "Would you like Hightouch to automatically detect if your PII data requires hashing?"
        }), "."]
      }), "\n", _jsx(_components.h2, {
        id: "tips-and-troubleshooting",
        children: "Tips and troubleshooting"
      }), "\n", _jsx(_components.h3, {
        id: "common-errors",
        children: "Common errors"
      }), "\n", _jsx(CommonErrorsPreface, {}), "\n", _jsx(_components.h4, {
        id: "event-time-is-older-than--old-events-cant-be-submitted",
        children: "Event time is older than {...}. Old events can't be submitted"
      }), "\n", _jsxs(_components.p, {
        children: ["If you receive this error for an event that isn't as old as the error message suggests, it may be because of an incorrect format for the ", _jsx(_components.code, {
          children: "event_timestamp"
        }), " field.\nMake sure that timestamps are in ", _jsx(_components.a, {
          href: "https://www.iso.org/iso-8601-date-and-time-format.html",
          children: "ISO 8601"
        }), " format, as described in the ", _jsx(_components.a, {
          href: "#event-timestamp",
          children: "event timestamp"
        }), " section above."]
      }), "\n", _jsx(_components.h3, {
        id: "live-debugger",
        children: "Live debugger"
      }), "\n", _jsx(LiveDebugger, {}), "\n", _jsx(_components.h3, {
        id: "sync-alerts",
        children: "Sync alerts"
      }), "\n", _jsx(SyncAlerts, {})]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
